import styled from 'styled-components';
export {
  ActivityIndicator,
  Button,
  LinkButton,
  FormActions,
  FormRow,
} from 'styles/components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
